export const ADD_LINK = 'ADD_LINK';

export const SHOW_ACCOUNT = 'SHOW_ACCOUNT';

export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';

export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';

export const SHOW_ACCOUNTS = 'SHOW_ACCOUNTS';

export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';

export const UPDATE_ACCOUNT_ERROR = 'UPDATE_ACCOUNT_ERROR';

export const UPDATE_PAYMENT = 'UPDATE_PAYMENT';

export const UPDATE_BILLING_PERIOD = 'UPDATE_BILLING_PERIOD';

export const UPDATE_PAYMENT_AND_SUBSCRIBE = 'UPDATE_PAYMENT_AND_SUBSCRIBE';

export const UPDATE_TRIAL_AND_SUBSCRIBE = 'UPDATE_TRIAL_AND_SUBSCRIBE';

export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';

export const ENABLE_RENEW = 'ENABLE_RENEW';

export const DISABLE_RENEW = 'DISABLE_RENEW';



// WEBPACK FOOTER //
// ./src/store/modules/content/types.js